export const pilingMachineIntegers = [];
export const pilingMachineFloats = [];
export const pilingMachineIsoStrings = [];
export const pilingMachineWhiteList = ['id', 'name', 'naskuMachineRef'];
export const pilingMachineOptimisticList = [
  ...pilingMachineWhiteList,
  'naskuLastOnlineAt',
  'naskuMachineStatus',
  'geom',
];
